import { call, put, takeLatest } from "redux-saga/effects"

// action
import {
    CANCEL_APPOINTMENT,
    cancelAppointmentFail,
    cancelAppointmentSuccess
} from '../action/cancelAppointmentAction'

// api 
import cancelAppointmentApi from '../api/cancelAppointmentApi'

export function* cancelAppointmentSaga(action) {
    try {
        const response = yield call(() => cancelAppointmentApi(action.params))
        if (response.data.status === 1) {
            yield put(cancelAppointmentSuccess(response, action))
        } else {
            yield put(cancelAppointmentFail(response, action))
        }
    }
    catch (e) {
        yield put(cancelAppointmentFail(e.response, action))
    }

}

export default function* mySaga() {
    yield takeLatest(CANCEL_APPOINTMENT, cancelAppointmentSaga)
}